import type { Venue } from '@cocoonspace/sdk-js/types/venue'
import { useListVenues } from '@cocoonspace/sdk-js/domains/spaces/spaces'

export const useListVenuesGroupedById = () => {
	return useListVenues(
		{},
		{
			query: {
				select: ({ data }) => {
					return data.reduce<Record<string, Venue>>(
						(acc, venue) => {
							acc[venue.id] = venue
							return acc
						},
						{} as Record<string, Venue>,
					)
				},
			},
		},
	)
}
